import { useState } from 'react';
import { useTripContext } from './TripContext';
import { useCreateTrip, useDeleteTrip } from './useTrips';

export function TripSwitcher() {
  const { trips, selectedTrip, selectTrip } = useTripContext();
  const [creating, setCreating] = useState(false);

  return (
    <div className="d-flex gap-2 align-items-center flex-wrap">
      <select
        className="form-select form-select-sm"
        style={{ maxWidth: 240 }}
        value={selectedTrip?.id ?? ''}
        onChange={(e) => selectTrip(e.target.value)}
        disabled={trips.length === 0}
      >
        {trips.length === 0 && <option value="">No trips yet</option>}
        {trips.map((t) => (
          <option key={t.id} value={t.id}>
            {t.name}
          </option>
        ))}
      </select>
      <button className="btn btn-primary btn-sm" onClick={() => setCreating((v) => !v)}>
        {creating ? 'Cancel' : 'New trip'}
      </button>
      {selectedTrip && <DeleteTripButton tripId={selectedTrip.id} name={selectedTrip.name} />}
      {creating && <NewTripForm onDone={() => setCreating(false)} />}
    </div>
  );
}

function NewTripForm({ onDone }: { onDone: () => void }) {
  const { selectTrip } = useTripContext();
  const createTrip = useCreateTrip();
  const [name, setName] = useState('');
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [tripType, setTripType] = useState('');

  const valid = name.trim() && start && end && start <= end;

  return (
    <form
      className="d-flex gap-2 align-items-center flex-wrap w-100 mt-2"
      onSubmit={(e) => {
        e.preventDefault();
        if (!valid) return;
        createTrip.mutate(
          { name: name.trim(), start, end, tripType: tripType.trim() || undefined },
          {
            onSuccess: (trip) => {
              selectTrip(trip.id);
              onDone();
            },
          },
        );
      }}
    >
      <input
        className="form-control form-control-sm"
        style={{ maxWidth: 200 }}
        placeholder="Trip name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <input
        className="form-control form-control-sm"
        style={{ width: 150 }}
        type="date"
        value={start}
        onChange={(e) => setStart(e.target.value)}
      />
      <input
        className="form-control form-control-sm"
        style={{ width: 150 }}
        type="date"
        value={end}
        onChange={(e) => setEnd(e.target.value)}
      />
      <input
        className="form-control form-control-sm"
        style={{ maxWidth: 180 }}
        placeholder="Trip type (optional)"
        value={tripType}
        onChange={(e) => setTripType(e.target.value)}
      />
      <button type="submit" className="btn btn-primary btn-sm" disabled={!valid || createTrip.isPending}>
        {createTrip.isPending ? 'Creating…' : 'Create'}
      </button>
      {start && end && start > end && (
        <span className="text-danger small">End must be on or after start</span>
      )}
    </form>
  );
}

function DeleteTripButton({ tripId, name }: { tripId: string; name: string }) {
  const deleteTrip = useDeleteTrip();
  return (
    <button
      className="btn btn-ghost btn-sm text-danger"
      title="Delete trip"
      onClick={() => {
        if (confirm(`Delete trip "${name}" and everything in it?`)) deleteTrip.mutate(tripId);
      }}
    >
      Delete
    </button>
  );
}
